import { createSlice } from "@reduxjs/toolkit";

export const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    getNotificationResult: false,
    getNotificationLoading: false,
    getNotificationError: false,
    addNotificationResult: false,
    addNotificationLoading: false,
    deleteNotificationResult: false,
  },
  reducers: {
    notificationReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_NOTIFICATION":
          return {
            ...state,
            getNotificationResult: payload.data,
            getNotificationLoading: payload.loading,
            getNotificationError: payload.error,
          };
        case "ADD_NOTIFICATION":
          return {
            ...state,
            addNotificationResult: payload.data,
            addNotificationLoading: payload.loading,
          };
        case "DELETE_NOTIFICATION":
          return {
            ...state,
            deleteNotificationResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { notificationReducers } = notificationSlice.actions;

export default notificationSlice.reducer;
